import { axios } from '../_helpers';

export const ElasticService = {
    pingHost,
    search
};

function pingHost() {
    return new Promise(function (resolve, reject) {
        axios.get('pingHost').then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

function search(query) {
    return new Promise(function (resolve, reject) {
        axios.post('search',query).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};



// WEBPACK FOOTER //
// ./src/_services/elastic.service.js